import { normalizeIntegrationProvider } from './integrations/integrationCatalog';

export interface ConnectionAccessVisibilityRow {
  isManagedByCurrentUser: boolean;
  isConnectionOwnedByCurrentUser: boolean;
}

export interface ProviderScopedConnectionAccessRow {
  provider: string;
}

export const getOwnedConnectionRows = <TRow extends ConnectionAccessVisibilityRow>(
  rows: TRow[]
): TRow[] => rows.filter((row) => row.isConnectionOwnedByCurrentUser);

export const getManagedConnectionRows = <TRow extends ConnectionAccessVisibilityRow>(
  rows: TRow[]
): TRow[] => rows.filter((row) => row.isManagedByCurrentUser);

export const getVisibleConnectionRows = <TRow extends ConnectionAccessVisibilityRow>(
  rows: TRow[]
): TRow[] => rows;

export const getProviderScopedConnectionRows = <TRow extends ProviderScopedConnectionAccessRow>(
  rows: TRow[],
  providerFilter?: string | null,
): TRow[] => {
  if (!providerFilter) {
    return rows;
  }

  const providerKey = normalizeIntegrationProvider(providerFilter);
  return rows.filter((row) => normalizeIntegrationProvider(row.provider) === providerKey);
};
